import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateMaintenanceWindowPatchManagementVendorProductSelector = document.createElement('template');

templateMaintenanceWindowPatchManagementVendorProductSelector.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">

    <div class="vendors-products">
      <gz-dropdown id="vendor-selector" labelWidth="240"></gz-dropdown>

      <gz-enum-filter id="product-selector" disabled="disabled" labelWidth="240"></gz-enum-filter>

      <gz-icon-button id="add-button" disabled size="32" fontSize="20" buttonType="square" icon="ds-icon-add" buttonFill="primary"></gz-icon-button>
    </div>

    <gz-grid-view id="vendor-products-pairs"></gz-grid-view>

  </div>
`;
